<template>
  <FormDropdown
    v-model="modelValue"
    name="position"
    :options="positionOptions"
    isRequired
  />
</template>

<script lang="ts" setup>
import { FormDropdownOption } from "@/components/FormDropdown.types";
import FormDropdown from "@/components/FormDropdown.vue";
import formatPlayerPosition from "@/lib/utils/string/formatPlayerPosition";
import { PlayerPosition } from "@shared/lib/database/enum.types";
import { ref } from "vue";

type PositionDropdownValue = PlayerPosition | null;

const modelValue = defineModel<PositionDropdownValue>({
  required: true,
});

const playerPositions: Array<PlayerPosition> = [
  "1",
  "2",
  "3",
  "4",
  "5",
];

const positionOptions = ref<Array<FormDropdownOption<PositionDropdownValue>>>([
  {
    label: "Select a position…",
    value: null,
    isDisabled: true,
  },
  ...playerPositions.map((position) => ({
    label: formatPlayerPosition(position),
    value: position,
  })),
]);
</script>
